import React from "react";
import PercentChange from "./PercentChange";
import StarIcon from "./StarIcon";
import { ExternalLink, LineChart } from "lucide-react";

const TableLine = ({ coin, index, onOpenModal }) => {
  const mktCapFormatter = (num) => {
    if (!num) return "-";
    if (num >= 1e9) {
      return (num / 1e9).toFixed(2) + " B$";
    } else if (num >= 1e6) {
      return (num / 1e6).toFixed(2) + " M$";
    } else {
      return num.toLocaleString() + " $";
    }
  };

  const priceFormatter = (num) => {
    if (num === null || num === undefined) return "-";
    if (num < 0.01) {
      return num.toFixed(6) + " $";
    } else if (num < 1) {
      return num.toFixed(4) + " $";
    } else {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 2,
      }).format(num);
    }
  };

  return (
    <div className="table-line" onClick={() => onOpenModal(coin)}>
      <div className="infos-container">
        <StarIcon coinId={coin.id} />
        <span className="rank-num">{index + 1}</span>
        <div className="img">
          <img src={coin.image} alt={coin.name} loading="lazy" />
        </div>
        <div className="infos">
          <button
            className="chart-btn"
            onClick={(e) => {
              e.stopPropagation();
              onOpenModal(coin);
            }}
            title="Open chart"
          >
            <LineChart size={15} />
          </button>
          <h4>{coin.name}</h4>
          <span className="ticker">{coin.symbol.toUpperCase()}</span>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={`https://www.coingecko.com/en/coins/${coin.id.toLowerCase()}`}
            onClick={(e) => e.stopPropagation()}
            className="info-link"
            title="CoinGecko page"
          >
            <ExternalLink size={13} />
          </a>
        </div>
      </div>

      <p className="price">{priceFormatter(coin.current_price)}</p>
      <p className="mktcap">{mktCapFormatter(coin.market_cap)}</p>
      <p className="volume">{mktCapFormatter(coin.total_volume)}</p>

      <PercentChange percent={coin.price_change_percentage_1h_in_currency} />
      <PercentChange percent={coin.market_cap_change_percentage_24h} />
      <PercentChange percent={coin.price_change_percentage_7d_in_currency} />
      <PercentChange percent={coin.price_change_percentage_30d_in_currency} />
      <PercentChange percent={coin.price_change_percentage_200d_in_currency} />
      <PercentChange percent={coin.price_change_percentage_1y_in_currency} />

      <div className="ath-col">
        {coin.ath_change_percentage > -3 ? (
          <span className="ath-tag">ATH !</span>
        ) : (
          <PercentChange percent={coin.ath_change_percentage} />
        )}
      </div>
    </div>
  );
};

export default TableLine;
